import React, { useState, useCallback } from "react";
import { Sun, Moon } from "lucide-react";

const PREF_KEY = "nl_theme_pref";

// Shared cream("day") / black("night") theme preference across all portals.
export function useTheme(fallback = "night") {
  const [theme, setTheme] = useState(() => localStorage.getItem(PREF_KEY) || fallback);
  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === "day" ? "night" : "day";
      localStorage.setItem(PREF_KEY, next);
      return next;
    });
  }, []);
  return [theme, toggle];
}

export function ThemeToggle({ theme, onToggle }) {
  return (
    <button
      onClick={onToggle}
      aria-label="Toggle light or dark theme"
      title={theme === "day" ? "Switch to dark" : "Switch to cream"}
      className="fixed bottom-6 left-6 z-[120] w-12 h-12 rounded-full flex items-center justify-center border border-[var(--nl-border-gold)] text-[var(--nl-gold)] bg-[var(--nl-bg-2)]/80 backdrop-blur-md hover:border-[var(--nl-gold)] hover:scale-105 transition-all duration-300 shadow-lg"
      data-testid="theme-toggle"
    >
      {theme === "day" ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  );
}
